import React from 'react';
import * as Sentry from "@sentry/react";
import { Button } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import FeedbackDialog from './FeedbackDialog';

const ErrorFallback: Sentry.FallbackRender = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">{t('components.errorBoundary.title')}</h1>
        <p className="text-xl mb-4">{t('components.errorBoundary.description')}</p>
        <div className="flex flex-col items-center space-y-4">
          <Button color="primary" onClick={() => window.location.reload()}>
            {t('components.errorBoundary.reloadButton')}
          </Button>
          <FeedbackDialog currentPage="error" buttonTitle={t('components.errorBoundary.contactSupportButton')} buttonSize='md' buttonColor='ghost'/>
        </div>
      </div>
    </div>
  );
};

const ErrorBoundary: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
